import { useNavigate } from "react-router-dom";
import styles from "../ClientManagement.module.css";

const RecentActivity = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.placeholderSection}>
            <h2>Recent Activity</h2>
            <p>This section will show recent client activities and updates.</p>
            <button 
                className={styles.backButton}
                onClick={() => navigate('/clients')}
            >
                ← Back to Dashboard
            </button>
        </div>
    );
};

export default RecentActivity;
